import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getOneRfidCard } from '../../../api/users';

const useRfidCard = (
  id: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['rfid', id],
    queryFn: () => getOneRfidCard(id),
    ...options,
  });
};

export default useRfidCard;
